import React from 'react';
import { View } from 'react-native';
import { styles } from './styles';

export const CardTemplate = ({ children, style = {}, ...props }) => (
  <View style={[styles.grid, style]} {...props}>{children}</View>
);

